import { Component, Input } from "@angular/core";
import { DownloadSvgComponent } from "src/constants/svg/download-svg.component";
import { SaveSvgComponent } from "src/constants/svg/save-svg.component";
import { ThumsUpSvgComponent } from "src/constants/svg/thums-up-svg.component";
import { ViewSvgComponent } from "src/constants/svg/view-svg.component";

@Component({
  selector: "app-card-activities",
  templateUrl: "./card-activities.component.html",
  styleUrls: ["./card-activities.component.scss"],
})
export class CardActivitiesComponent {
  @Input() downloadCount!: string | number;
  @Input() saveFileCount!: string | number;
  @Input() viewCount!: string | number;
  @Input() likeCount!: string | number;

  viewSVGComponentRef = ViewSvgComponent;
  saveSVGComponentRef = SaveSvgComponent;
  likeSVGComponentRef = ThumsUpSvgComponent;
  downloadSVGComponentRef = DownloadSvgComponent;
}
